import { pushDatalayer } from '../utilities/datalayer';

export default class ClickDatalayer {
    constructor(el) {
        this.DOM = { el: el };
        this.clickDatalayer = JSON.parse(this.DOM.el.dataset.clickDatalayer || '{}');

        el.addEventListener('click', () => {
            pushDatalayer(this.clickDatalayer);
        })
    }
}

const clickDatalayerNodes = Array.from(document.querySelectorAll('[data-click-datalayer]'));
if (clickDatalayerNodes !== null) {
    clickDatalayerNodes.forEach((node) => { new ClickDatalayer(node); });
}
